module.exports = __webpack_public_path__ + "img/share-mode-flow1.c000fd21.png";